<template>
    <div class="auto-refresh">
      <slot></slot>
    </div>
</template>
<script>
export default {
  name: 'AutoRefresh',
  components: {
  }, 
  props: {
    interval: {
      type: Number,
      default: 1000
    }
  },
  data() {
    return {
        intervalIns: undefined
    }
  },
  mounted() {
    let self = this
    this.$emit('start');
    this.intervalIns = setInterval(function() {
      self.$emit('refresh');
    }, this.interval)
  },
  destroyed() {
    if (this.intervalIns) {
      clearInterval(this.intervalIns)
      this.intervalIns = undefined
    }
    this.$emit('end');
  },
}
</script>
<style lang="scss" scoped></style>
